import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "./BaseUrl";
import InnerHeader from "./InnerHeader";
// import Box from '@mui/material/Box';
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
//import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from "@mui/material/FormControl";
// import MyDocument1 from './MyDocument1';
import { pdf } from "@react-pdf/renderer";
import MyDocument3 from "./MyDocument3";
import TestDocument from "./TestDocument";
import { StyledDataGrid } from "./StyledDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";

const FinalExam = () => {
    const [uid, setUid] = useState([]);
    const [data, setData] = useState([]);
    const [course, SetCourse] = useState([]);
    const [error, setError] = useState({});
    const [student, setstudent] = useState([]);
    const [Courseid, setCourseid] = useState([]);
    const [AnnulBatch, setAnnulBatch] = useState([]);

    const [value, setValue] = useState({
        batch: "",
        student: "",
        course: "",
        row_radio_buttons_group: "",
    });


    const validateForm = () => {
        let isValid = true
        const newErrors = {}

        if (!value.college) {
            isValid = false;
            newErrors.name = "Name is require"
        }
        if (!value.email) {
            isValid = false;
            newErrors.email = "Email is require"
        }
        setError(newErrors)
        return isValid
    }





    useEffect(() => {
        getCourseData();
        value.title = "";
        setError({});
        setUid([]);
    }, []);




    async function getCourseData() {
        axios
            .get(`${BASE_URL}/getCourse`)
            .then((res) => {
                console.log(res.data);
                SetCourse(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const getstudent = async (Id) => {
        const data = {
            batch_Id: Id,
        };
        try {
            const res = await axios.post(`${BASE_URL}/getbatchidwisestudent`, data);
            setstudent(res.data);
        } catch (err) {
            console.error("Error fetching data:", err);
        }
    };

    const getbatch = async (Visit_Id) => {
        if (Visit_Id != undefined) {
            setCourseid(Visit_Id);

            const data = {
                courseid: Visit_Id,
            };

            try {
                const res = await axios.post(`${BASE_URL}/getcoursewisebatch`, data);
                setAnnulBatch(res.data);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        } else {
            const data = {
                tablename: "Batch_Mst",
                columnname: "Batch_Id,Batch_code",
            };
            axios
                .post(`${BASE_URL}/get_new_data`, data)
                .then((res) => {
                    setAnnulBatch(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const onhandleChange = (e) => {
        if ([e.target.name] == "row_radio_buttons_group") {

            setValue({
                batch: "",
                student: "",
                course: "",
                row_radio_buttons_group: "",
            })

        }
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        if ([e.target.name] == "course") {
            getbatch(e.target.value);
        }
        if ([e.target.name] == "batch") {
            getstudent(e.target.value);
        }
    };

    const roledata = {
        role: Cookies.get(`role`),
        pageid: 56,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);



    async function downloadPDF(id) {

        if (!id) {
            alert('Pls Select the Batch');
            return
        }

        axios
            .post(`${BASE_URL}/getfinalreport`, { Batch_Id: id, Student_Id: value.student })
            .then((res) => {
                setData(res.data);

                Blob(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const Blob = async (data) => {
        try {
            // Generate PDF
            //   const blob = await pdf(<MyDocument3 data={data} />).toBlob();
            const blob = await pdf(<TestDocument data={data} />).toBlob();

            const url = URL.createObjectURL(blob);

            // Display PDF in a new tab
            window.open(url);

            // Optionally, if you still want to offer a download link:
            // const a = document.createElement('a');
            // a.href = url;
            // a.download = 'admission.pdf';
            // a.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error generating PDF:", err);
        }

        // const blob = await pdf(<MyDocument3 data={data} />).toBlob();
        // const url = URL.createObjectURL(blob);
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = 'admission.pdf';
        // a.click();
        // // URL.revokeObjectURL(url);
    };


    return (
        <div class="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Final Exam</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3" >
                                        <div class="row">
                                            <div class="from-group col-lg-12">
                                                <FormControl>
                                                    <RadioGroup
                                                        row
                                                        onChange={onhandleChange}
                                                        defaultValue={`1`}
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row_radio_buttons_group"
                                                    >
                                                        <FormControlLabel
                                                            value="1"
                                                            control={<Radio />}
                                                            label="Batchwise"
                                                        />
                                                        <FormControlLabel
                                                            value="2"
                                                            control={<Radio />}
                                                            label="Studentwise"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </div>
                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">
                                                    Select Course<span className="text-danger">*</span>{" "}
                                                </label>
                                                <select
                                                    class="form-control form-control-lg"
                                                    id="exampleFormControlSelect1"
                                                    value={value.course}
                                                    onChange={onhandleChange}
                                                    name="course"
                                                >
                                                    <option>Select</option>
                                                    {course.map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">
                                                    Select Batch<span className="text-danger">*</span>{" "}
                                                </label>
                                                <select
                                                    class="form-control form-control-lg"
                                                    id="exampleFormControlSelect1"
                                                    value={value.batch}
                                                    onChange={onhandleChange}
                                                    name="batch"
                                                >
                                                    <option>Select</option>
                                                    {AnnulBatch.map((item) => {
                                                        return <option value={item.Batch_Id}>{item.Batch_code}</option>;
                                                    })}
                                                </select>
                                            </div>
                                            {value.row_radio_buttons_group === "2" && (
                                                <div class="form-group col-lg-4">
                                                    <label for="exampleFormControlSelect1">
                                                        Select Student<span className="text-danger">*</span>{" "}
                                                    </label>
                                                    <select
                                                        class="form-control form-control-lg"
                                                        id="exampleFormControlSelect1"
                                                        value={value.student}
                                                        onChange={onhandleChange}
                                                        name="student"
                                                    >
                                                        <option>Select</option>

                                                        {student &&
                                                            student.map((item) => {
                                                                return (
                                                                    <option value={item.Student_Id}>
                                                                        {item.Student_Name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            )}
                                        </div>

                                        {/* <button type="submit" className="btn btn-primary mr-2 ">
                                            Excel
                                        </button> */}
                                        <button
                                            type="button"
                                            className="btn btn-primary mr-2"
                                            onClick={() => downloadPDF(value.batch)}
                                        >
                                            Show
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setValue({
                                                    batch: "",
                                                    student: "",
                                                    course: "",
                                                    row_radio_buttons_group: "",
                                                })
                                            }}
                                            class="btn btn-primary mr-2  "
                                        >
                                            Cancel
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinalExam;
